import { Component, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { faExclamationCircle, faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { AuthService } from 'src/app/auth/auth.service';
import { SppdashboardService } from '../dashboard/sppdashboard.service';
import { differenceInDays } from 'date-fns';
import { alumniReasonList, namewithSpace } from 'src/app/utils/constants';
import { environment } from 'src/environments/env';
import { MctAddEditAnnouncementComponent } from '../admin/mct-announcement/mct-add-edit-announcement/mct-add-edit-announcement.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HelpdeskService } from '../admin/helpdesk/helpdesk.service';

@Component({
  selector: 'app-alumni-request',
  standalone: false,
  templateUrl: './alumni-request.component.html',
  styleUrl: './alumni-request.component.scss'
})
export class AlumniRequestComponent {

  icons = {
    faExclamationCircle,
    faInfoCircle
  }

  status: string = '';
  alumniStatus: string | null = null;
  show: boolean | null = null;
  alumniForm: any;
  // emailp: string = null;
  rtimeline: any;
  daysDifference: any;
  submitSuccess: boolean = false;
  userid: any = null;
  activeSince: any = null;
  endDate: any = null;
  isCheckboxSelected = false;
  formSubmitted: boolean = false;
  public snackbar = inject(MatSnackBar);

  constructor(private _fb: FormBuilder, private _auth: AuthService,
    private sppdashboardService: SppdashboardService,
    private helpService: HelpdeskService,
  ) { }

  reasonOptions = alumniReasonList;

  ngOnInit(): void {
    this.initForm();
    this.getuserDetails();
  }

  // Custom validator for checkbox field
  checkboxRequired(control: any) {
    const value = control.value;
    return value && value.length > 0 ? null : { required: true };
  }

  initForm() {
    this.alumniForm = this._fb.group({
      firstname: ['', [Validators.required, Validators.pattern(namewithSpace)]],
      lastname: ['', [Validators.required, Validators.pattern(namewithSpace)]],
      email: [{value: '', disabled: true}, [Validators.required]],
      alumniText: [''],
      alumniReasons: [[], [this.checkboxRequired.bind(this)]],
      mctAlumniAgreement: [{ value: '', disabled: true }, [Validators.required]]
    });
  }

  getuserDetails() {
    this.sppdashboardService.getUser().subscribe((response: any) => {
      if (response?.success === true) {

        // this.emailp = response?.data?.email;
        this.userid = response?.data?.userid;

        if (response?.success === true) {
          this.status = response?.data?.status;
          this.alumniStatus = response?.data?.alumniStatus;

          this.activeSince = response?.data?.firstTimeRegDate;
          this.endDate = response?.data?.mctSubscriptionEndDate;

          this.alumniForm.patchValue({
            firstname: response?.data?.firstname,
            lastname: response?.data?.lastname,
            email: response?.data?.email,
            mctAlumniAgreement: response?.data?.mctAlumniAgreement
          })

          this.rtimeline = sessionStorage.getItem('remindertimeline')
            ? Number(sessionStorage.getItem('remindertimeline'))
            : '';

          const currentDate = new Date();
          const endDate = new Date(response?.data?.mctSubscriptionEndDate ? response?.data?.mctSubscriptionEndDate : new Date());
          const reminderDate = new Date(endDate);
          reminderDate.setDate(reminderDate.getDate() - this.rtimeline);
          this.daysDifference = differenceInDays(currentDate, reminderDate);

          if (currentDate >= reminderDate && this.daysDifference <= this.rtimeline) {
            this.show = true;

          } else {
            this.show = false;
          }
        }
      }
    })
  }


  agrementDoc = () => {
    this.alumniForm.get('mctAlumniAgreement')?.enable();
    const pdfUrl = environment.BASE_URL + `/ptp/api/spp/mct/mct_alumni_agreement/download`;
    window.open(pdfUrl, '_blank');
  }


  onReasonChange(event: any, reasonValue: string): void {
    const currentReasons = this.alumniForm.get('alumniReasons')?.value || [];

    if (event.checked) {
      // Add reason if checked
      if (!currentReasons.includes(reasonValue)) {
        currentReasons.push(reasonValue);
      }
    } else {
      // Remove reason if unchecked
      const index = currentReasons.indexOf(reasonValue);
      if (index > -1) {
        currentReasons.splice(index, 1);
      }
    }

    this.alumniForm.get('alumniReasons')?.setValue([...currentReasons]);
    // Mark the field as touched to trigger validation display
    this.alumniForm.get('alumniReasons')?.markAsTouched();
  }

  isReasonSelected(reasonValue: string): boolean {
    const currentReasons = this.alumniForm.get('alumniReasons')?.value || [];
    return currentReasons.includes(reasonValue);
  }

  // Getter for easy access to checkbox form control
  get alumniReasonsControl() {
    return this.alumniForm.get('alumniReasons');
  }

  submit(): void {
    this.formSubmitted = true;
    this.alumniForm.markAllAsTouched();
    this.alumniForm.updateValueAndValidity();

    if (this.alumniForm.valid && this.isCheckboxSelected) {      
      this.sppdashboardService.sumbmitAluminiRequest(this.alumniForm.value, this.userid).subscribe((res: any) => {
        if (res?.success === true) {
          this.show = false;
          this.submitSuccess = true;
          this.status = res?.data?.status;
          this.alumniStatus = res?.data?.alumniStatus;
          this.sendEmail();
        }
      });
    }
  }


  sendEmail(): void {

      if (this.alumniForm.getRawValue()?.email) {
        const tempObject = {
          "recipientEmail": this.alumniForm.getRawValue()?.email,
          "subject": 'Alumni Request Approved',
          "templateName": 'MCTAlumniApproval',
          "language": "en",
          "customContext": "{}"
        }

        this.helpService.sendEmail(tempObject).subscribe((res: any) => {
          if (res.success === true) {
            
          } else {
            this.snackbar.open(res.errors, '', { verticalPosition: 'top', horizontalPosition: 'center' });
          }
        }, (error: any) => {
          const errMsg = error?.error?.errors ? error?.error?.errors : [error?.error?.error];
          errMsg && errMsg.map((msg: string) => {
            this.snackbar.open(msg, '', { verticalPosition: 'top', horizontalPosition: 'right', panelClass: ['warning'] });
          });
        })
      }
  }


  ngOnDestroy(): void {
    this.submitSuccess = false;
  }

}
